import InteractionPane from "interactionpane";
import React, { useState } from "react";
const CameraComponent = () => {
    const [scale, setScale] = useState(1);
    const [offset, setOffset] = useState({ x: 0, y: 0 });

   
  return (
    <div className="container-xxl flex-grow-1 container-p-y">
      <div className="row">
        <div className="col-md-6">

        <InteractionPane
      scale={scale}
      setScale={setScale}
      offset={offset}
      setOffset={setOffset}
    >
      <img
        src="https://github.githubassets.com/assets/GitHub-Mark-ea2971cee799.png"
        width="200px"
        style={{ position: "absolute", left: "200px" }}
        alt="poop"
      />
      <div
        style={{
          position: "absolute",
          width: "400px",
          height: "400px",
          left: "0px",
          top: "0px",
          borderColor: "red",
          borderStyle: "solid",
        }}
      ></div>
      <div style={{ position: "absolute" }}>
        <svg height="400" width="400">
          <polygon points="0,200 200,200 100,0 0,200" class="triangle" />
          <circle cx="300" cy="300" r="100" fill="blue" />
        </svg>
      </div>
    </InteractionPane>
        
        
        </div>
      </div>
    </div>
  );
};

export default CameraComponent;
